import * as React from 'react';

import { Row, Col, Form, Tabs, TimePicker, DatePicker } from 'antd';
import {
  Input,
  Notification,
  Select,
  SelectOption as Option,
  Space,
  Text,
} from 'farmhub-ui-core';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { useAppDispatch, useAppSelector } from 'app';
import { entityTypes } from 'commons';
import { Footer, PageTitleBar } from 'components';
import { ClockIcon, SlackIcon, TelegramContactIcon } from 'components/Icon';
import MainContent from 'components/Layout/MainContent';
import { createEntityReport } from 'slice';
import { theme } from 'styled';
import { SELECTED_ENTITY } from 'types';
import {
  NOTIFY_APP,
  REPORT_OPTION,
  DAY_OF_WEEK,
  ENTITY_REPORT_TYPE,
  ENTITY_REPORT_TYPE_VALUE,
  ENTITY_REPORT_STATUS,
  ENTITY_REPORT_TARGET_TYPE,
  NOTIFY_STATUS,
} from 'utils';

import { ReportFeature } from './ReportFeature';
import { SlackApp } from './SlackApp';
import { TelegramApp } from './TelegramApp';

const WrapSelectTimeType = styled.div`
  display: flex;
  align-items: center;
`;

const WrapperTimePicker = styled.div`
  display: flex;
  justify-content: space-between;
  width: 340px;
  height: 42px;
  border-radius: 6px;
  border: 1px solid ${props => props.theme.colors.border.main};
`;

const WrapDateTime = styled.div`
  display: flex;
`;

const WrapTime = styled.div<{
  typeReport: number;
}>`
  width: ${p =>
    ENTITY_REPORT_TYPE_VALUE.DATE_REPORT == p.typeReport ? '290px' : '145px'};
  height: 42px;
  margin: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid ${p => p.theme.colors.border.light};
  .ant-picker {
    border: none !important;
    border-radius: 0px !important;
    outline: none !important;
    height: 30px;
    width: 80px;
  }

  .ant-picker-focused {
    border: none !important;
    border-radius: 0px !important;
    outline: none !important;
    box-shadow: none;
  }

  .anticon,
  .anticon-close-circle {
    display: none;
  }

  .ant-form-item-explain-error {
    color: #f5222d;
    position: absolute;
    bottom: -35px;
    width: max-content;
    right: 0px;
  }
`;

const RangeTimeWrapper = styled.div`
  width: 290px;
  height: 50px;
  margin: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid ${p => p.theme.colors.border.light};
  .ant-picker {
    border: none !important;
    border-radius: 0px !important;
    outline: none !important;
    height: 30px;
    width: 100%;
  }

  .ant-picker-focused {
    border: none !important;
    border-radius: 0px !important;
    outline: none !important;
    box-shadow: none;
  }

  .anticon-close-circle {
    display: none;
  }

  .ant-form-item-explain-error {
    color: #f5222d;
    position: absolute;
    bottom: -35px;
    width: max-content;
    right: 0px;
  }
`;

const WrapDayOfWeek = styled.div`
  display: flex;
  align-items: center;
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
    box-shadow: none;
  }

  .ant-select-selector {
    border: none;
    box-shadow: none;
  }

  .ant-form-item-explain-error {
    color: #f5222d;
    position: absolute;
    bottom: -32px;
    width: max-content;
  }
`;

const WrapperClockIcon = styled.div`
  border-left: 1px solid #f1f1f1;
  width: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const WrapDate = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 145px;
  padding: 5px;
  border-right: 1px solid ${p => p.theme.colors.border.light};
  color: ${props => props.theme.colors.text.secondary};
  margin: 0px;
  .ant-picker {
    border: none !important;
    border-radius: 0px !important;
    outline: none !important;
    height: 30px;
    width: 80px;
  }

  .ant-picker-focused {
    border: none !important;
    border-radius: 0px !important;
    outline: none !important;
    box-shadow: none;
  }

  //.ant-form-item-explain,
  .ant-form-item-explain-error {
    position: absolute;
    bottom: -30px;
    width: 200px;
    right: 0px;
  }

  .anticon,
  .anticon-close-circle {
    display: none;
  }

  .ant-form-item-explain-error {
    color: #f5222d;
    position: absolute;
    bottom: -35px;
    width: max-content;
    right: 0px;
  }
`;

const WrapHyphen = styled.div`
  width: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

type CreateBodyProps = {
  entityID: string;
  name?: string;
  status?: number;
  entityReportApps: any[];
  type: number;
  targetType: number;
  statisticOption?: any[];
  receivedReportTime?: any;
  statisticStartTime: any;
  statisticEndTime: any;
  googleSheetUrl?: string;
  googleSheetInfo?: {
    sheetName: string;
    row: string;
    column: string;
  };
};

type RelativeDate = {
  minutes?: number;
  hours?: number;
  date?: number;
  dayOfWeek?: number;
  absoluteTime?: string;
};

export const EntityReportCreatePage = (): JSX.Element => {
  const [form] = Form.useForm();
  const [listSlackGroup, setListSlackGroup] = React.useState<any[]>([]);
  const [listTelegramGroup, setListTelegramGroup] = React.useState<any[]>([]);
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const selectedEntity = localStorage.getItem(SELECTED_ENTITY);
  const { type: entityType } = JSON.parse(selectedEntity as string);
  // 0: 'user', 1: 'farm', 2: 'store', 3: 'collaborator', 4: 'warehouse', 5: 'transport', 6: 'volunteer'
  const entityTypeStr = entityTypes[entityType];
  const [typeReport, setTypeReport] = React.useState<number>();
  const [item, setItem] = React.useState({});
  const [title, setTitle] = React.useState<string>('');
  const entityID = useAppSelector(state => state.account.item?.id);

  const handleSetBodyUpdate = value => {
    setItem({ ...item, ...value });
  };

  const handleSubmitBodyCreate = () => {
    if (!entityID) {
      return;
    }
    form.validateFields().then(async values => {
      const feature: any[] = [];
      const isReportTypeASAP =
        Number(values.type) === ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT;
      setIsSubmitting(true);

      Object.keys(REPORT_OPTION).forEach(item => {
        const option: any = {
          type: REPORT_OPTION[item].type,
          options: [],
        };

        if (isReportTypeASAP) {
          option.options.push(values[`option${REPORT_OPTION[item].type}`]);
        } else {
          REPORT_OPTION[item].options.forEach(childItem => {
            if (
              values[`option${REPORT_OPTION[item].type}.${childItem.type}`] ==
              true
            ) {
              option.options.push(childItem.type);
            }
          });
        }

        feature.push(option);
      });

      const receivedReportTime: RelativeDate = {};
      const statisticEndTime: RelativeDate = {};
      const statisticStartTime: RelativeDate = {};

      if (values?.timeReport) {
        receivedReportTime.hours = values?.timeReport
          ? values.timeReport?._d.getHours()
          : 12;
        receivedReportTime.minutes = values?.timeReport
          ? values.timeReport?._d.getMinutes()
          : 0;

        if (values?.dayOfWeekReport) {
          receivedReportTime.dayOfWeek = values.dayOfWeekReport;
        }

        if (values?.dateReport) {
          receivedReportTime.date = values.dateReport?._d.getDate();
        }
      }

      if (values?.timeReportEnd) {
        statisticEndTime.hours = values?.timeReportEnd
          ? values.timeReportEnd?._d.getHours()
          : 12;
        statisticEndTime.minutes = values?.timeReportEnd
          ? values.timeReportEnd?._d.getMinutes()
          : 0;

        if (values?.dayOfWeekReport) {
          statisticEndTime.dayOfWeek = values.dayOfWeekReportEnd;
        }

        if (values?.dateReport) {
          statisticEndTime.date = values.dateReportEnd?._d.getDate();
        }
      }

      if (values?.timeReportStart) {
        statisticStartTime.hours = values?.timeReportStart
          ? values.timeReportStart?._d.getHours()
          : 12;
        statisticStartTime.minutes = values?.timeReportStart
          ? values.timeReportStart?._d.getMinutes()
          : 0;

        if (values?.dayOfWeekReport) {
          statisticStartTime.dayOfWeek = values.dayOfWeekReportStart;
        }

        if (values?.dateReport) {
          statisticStartTime.date = values.dateReportStart?._d.getDate();
        }
      }

      if (values?.timeReportASAP) {
        statisticStartTime.absoluteTime = moment(
          values?.timeReportASAP[0]
        ).format();
        statisticEndTime.absoluteTime = moment(
          values?.timeReportASAP[1]
        ).format();
      }

      const createBody: CreateBodyProps = {
        entityID,
        name: values.name,
        status: ENTITY_REPORT_STATUS.ACTIVATED,
        entityReportApps: [],
        type: Number(values.type),
        targetType: ENTITY_REPORT_TARGET_TYPE.ORDER,
        statisticOption: feature,
        receivedReportTime,
        statisticEndTime,
        statisticStartTime,
        googleSheetUrl: values.googleSheetUrl || '',
      };

      if (isReportTypeASAP) {
        createBody.googleSheetInfo = {
          sheetName: values.googleSheetInfoSheetName,
          row: values.googleSheetInfoRow,
          column: values.googleSheetInfoColumn,
        };
      }

      if (!isReportTypeASAP) {
        createBody?.entityReportApps.push({
          type: NOTIFY_APP.SLACK,
          status: NOTIFY_STATUS.ACTIVATED,
          urlInformation: listSlackGroup || [],
        });

        createBody?.entityReportApps.push({
          type: NOTIFY_APP.TELEGRAM,
          status: NOTIFY_STATUS.ACTIVATED,
          urlInformation: listTelegramGroup || [],
        });
      }

      try {
        await dispatch(createEntityReport(createBody)).unwrap();

        history.push(`/settings/entity-report/list`);
      } catch (error: any) {
        Notification('error', 'Tạo báo cáo thất bại', error);
      } finally {
        setIsSubmitting(false);
      }
    });
  };

  return (
    <Form form={form} onValuesChange={handleSetBodyUpdate}>
      <MainContent hasFooter>
        <PageTitleBar title="Thêm mới báo cáo nhận đơn" />
        <Space height={25} />
        <Text size="xxs" textTransform="uppercase" weight="extraBold">
          Thông tin cơ bản
        </Text>
        <Space height={15} />
        <Row>
          <Col
            lg={6}
            md={6}
            sm={24}
            style={{ display: 'flex', alignItems: 'center', height: '50px' }}
          >
            <Text>Tiêu đề:</Text>
          </Col>
          <Col lg={18}>
            <Form.Item name="name">
              <Input
                height={theme.input.height.md}
                placeholder="Nhập tiêu đề tại đây"
                value={title}
                width="693px"
                onChange={e => {
                  setTitle(e.target.value);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col
            lg={6}
            md={6}
            sm={24}
            style={{ display: 'flex', alignItems: 'center', height: '50px' }}
          >
            <Text>Link google sheet:</Text>
          </Col>
          <Col lg={18}>
            <Form.Item name="googleSheetUrl" style={{ marginBottom: '0px' }}>
              <Input
                height={theme.input.height.md}
                placeholder="Nhập url tại đây"
                value={title}
                width="693px"
                onChange={e => {
                  setTitle(e.target.value);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        {typeReport != undefined &&
          typeReport == ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT && (
            <>
              <Space height={20} />
              <Row>
                <Col
                  lg={6}
                  md={6}
                  sm={24}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '50px',
                  }}
                >
                  <Text>Thông tin google sheet:</Text>
                </Col>
                <Col lg={18}>
                  <Row justify="space-between" style={{ width: '693px' }}>
                    <Form.Item
                      name="googleSheetInfoSheetName"
                      style={{ marginBottom: '0px' }}
                    >
                      <Input
                        height={theme.input.height.md}
                        placeholder="Tên sheet"
                        width="224px"
                      />
                    </Form.Item>
                    <Form.Item
                      name="googleSheetInfoRow"
                      style={{ marginBottom: '0px' }}
                    >
                      <Input
                        height={theme.input.height.md}
                        placeholder="Số hàng chứa mã code của KH"
                        width="224px"
                      />
                    </Form.Item>
                    <Form.Item
                      name="googleSheetInfoColumn"
                      style={{ marginBottom: '0px' }}
                    >
                      <Input
                        height={theme.input.height.md}
                        placeholder="Số cột chứa mã SKU của SP"
                        width="224px"
                      />
                    </Form.Item>
                  </Row>
                </Col>
              </Row>
            </>
          )}
        <Space height={20} />
        <Row>
          <Col
            lg={6}
            md={6}
            sm={24}
            style={{ display: 'flex', alignItems: 'center', height: '50px' }}
          >
            <Text>Thời gian báo cáo:</Text>
          </Col>
          <Col lg={18}>
            <WrapSelectTimeType>
              <Form.Item name="type" style={{ marginBottom: '0px' }}>
                <Select
                  showSearch
                  height={theme.select.height.md}
                  placeholder="Chọn loại báo cáo"
                  styles={{
                    borderRadius: '0px 6px 6px 0px',
                    borderLeft: 'none',
                  }}
                  width="340px"
                  onChange={e => {
                    setTypeReport(e);
                  }}
                >
                  {(ENTITY_REPORT_TYPE || []).map((item: any) => (
                    <Option value={item.type}>{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>
              {typeReport != undefined &&
                typeReport != ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT && (
                  <>
                    <Space width={12} />
                    <WrapperTimePicker>
                      <WrapDateTime>
                        <WrapTime typeReport={typeReport}>
                          <Form.Item
                            name="timeReport"
                            rules={[
                              {
                                required: true,
                                message: 'Vui lòng chọn giờ!',
                              },
                            ]}
                            style={{ marginBottom: '0px', border: 'none' }}
                          >
                            <TimePicker format="HH:mm" placeholder="Chọn giờ" />
                          </Form.Item>
                        </WrapTime>

                        <WrapDayOfWeek>
                          {typeReport ===
                            ENTITY_REPORT_TYPE_VALUE.WEEK_REPORT && (
                            <Form.Item
                              name="dayOfWeekReport"
                              rules={[
                                {
                                  required: true,
                                  message: 'Vui lòng chọn thứ!',
                                },
                              ]}
                              style={{ marginBottom: '0px' }}
                            >
                              <Select
                                showSearch
                                height={theme.select.height.sm}
                                placeholder="Chọn thứ"
                                styles={{
                                  borderRadius: '0px 6px 6px 0px',
                                  border: 'none !important',
                                  borderLeft: 'none',
                                }}
                                width="145px"
                                onChange={e => {
                                  console.log(e);
                                }}
                              >
                                {(DAY_OF_WEEK || []).map((item: any) => (
                                  <Option value={item.type}>{item.name}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          )}
                        </WrapDayOfWeek>
                        {typeReport ===
                          ENTITY_REPORT_TYPE_VALUE.MONTH_REPORT && (
                          <WrapDate>
                            Ngày:{' '}
                            <Form.Item
                              name="dateReport"
                              rules={[
                                {
                                  required: true,
                                  message: 'Vui lòng chọn ngày!',
                                },
                              ]}
                              style={{ marginBottom: '0px' }}
                            >
                              <DatePicker
                                format="DD"
                                picker="date"
                                placeholder="Chọn ngày"
                                size="small"
                              />
                            </Form.Item>
                          </WrapDate>
                        )}
                      </WrapDateTime>
                      {/* Quý: <DatePicker size="small" picker="quarter" format="Q" /> */}
                      <WrapperClockIcon>
                        <ClockIcon width={18} />
                      </WrapperClockIcon>
                    </WrapperTimePicker>
                  </>
                )}
            </WrapSelectTimeType>
          </Col>
        </Row>
        <Space height={40} />

        <Row>
          <Col
            lg={6}
            md={6}
            sm={24}
            style={{ display: 'flex', alignItems: 'center', height: '50px' }}
          >
            <Text>Thời gian tổng hợp dữ liệu</Text>
          </Col>

          <Col lg={18}>
            <Row>
              <WrapperTimePicker>
                <WrapDateTime>
                  {typeReport != undefined &&
                    typeReport !== ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT && (
                      <WrapTime typeReport={typeReport}>
                        <Form.Item
                          name="timeReportStart"
                          style={{ marginBottom: '0px', border: 'none' }}
                        >
                          <TimePicker format="HH:mm" placeholder="Chọn giờ" />
                        </Form.Item>
                      </WrapTime>
                    )}

                  {typeReport != undefined &&
                    typeReport === ENTITY_REPORT_TYPE_VALUE.WEEK_REPORT && (
                      <WrapDayOfWeek>
                        <Form.Item
                          name="dayOfWeekReportStart"
                          style={{ marginBottom: '0px' }}
                        >
                          <Select
                            showSearch
                            height={theme.select.height.sm}
                            placeholder="Chọn thứ"
                            styles={{
                              borderRadius: '0px 6px 6px 0px',
                              border: 'none !important',
                              borderLeft: 'none',
                            }}
                            width="145px"
                            onChange={e => {
                              console.log(e);
                            }}
                          >
                            {(DAY_OF_WEEK || []).map((item: any) => (
                              <Option value={item.type}>{item.name}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </WrapDayOfWeek>
                    )}

                  {typeReport != undefined &&
                    typeReport === ENTITY_REPORT_TYPE_VALUE.MONTH_REPORT && (
                      <WrapDate>
                        Ngày:{' '}
                        <Form.Item
                          name="dateReportStart"
                          style={{ marginBottom: '0px' }}
                        >
                          <DatePicker
                            // defaultValue={moment('12', 'DD')}
                            format="DD"
                            picker="date"
                            placeholder="Chọn ngày"
                            size="small"
                          />
                        </Form.Item>
                      </WrapDate>
                    )}

                  {typeReport != undefined &&
                    typeReport === ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT && (
                      <RangeTimeWrapper>
                        <Form.Item
                          name="timeReportASAP"
                          style={{ marginBottom: '0px', border: 'none' }}
                        >
                          <DatePicker.RangePicker
                            showTime
                            defaultValue={[moment(), moment().add(1, 'h')]}
                            format="DD/MM/YYYY HH:mm"
                            suffixIcon={<></>}
                          />
                        </Form.Item>
                      </RangeTimeWrapper>
                    )}
                </WrapDateTime>
                {/* Quý: <DatePicker size="small" picker="quarter" format="Q" /> */}
                <WrapperClockIcon>
                  <ClockIcon width={18} />
                </WrapperClockIcon>
              </WrapperTimePicker>
              {typeReport != undefined &&
                typeReport !== ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT && (
                  <>
                    <WrapHyphen>-</WrapHyphen>
                    <WrapperTimePicker>
                      <WrapDateTime>
                        <WrapTime typeReport={typeReport}>
                          <Form.Item
                            name="timeReportEnd"
                            style={{ marginBottom: '0px', border: 'none' }}
                          >
                            <TimePicker format="HH:mm" placeholder="Chọn giờ" />
                          </Form.Item>
                        </WrapTime>

                        {typeReport ===
                          ENTITY_REPORT_TYPE_VALUE.WEEK_REPORT && (
                          <WrapDayOfWeek>
                            <Form.Item
                              name="dayOfWeekReportEnd"
                              style={{ marginBottom: '0px' }}
                            >
                              <Select
                                showSearch
                                height={theme.select.height.sm}
                                placeholder="Chọn thứ"
                                styles={{
                                  borderRadius: '0px 6px 6px 0px',
                                  border: 'none !important',
                                  borderLeft: 'none',
                                }}
                                width="145px"
                                onChange={e => {
                                  console.log(e);
                                }}
                              >
                                {(DAY_OF_WEEK || []).map((item: any) => (
                                  <Option value={item.type}>{item.name}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </WrapDayOfWeek>
                        )}

                        {typeReport ===
                          ENTITY_REPORT_TYPE_VALUE.MONTH_REPORT && (
                          <WrapDate>
                            Ngày:{' '}
                            <Form.Item
                              name="dateReportEnd"
                              style={{ marginBottom: '0px' }}
                            >
                              <DatePicker
                                format="DD"
                                picker="date"
                                placeholder="Chọn ngày"
                                size="small"
                              />
                            </Form.Item>
                          </WrapDate>
                        )}
                      </WrapDateTime>
                      {/* Quý: <DatePicker size="small" picker="quarter" format="Q" /> */}
                      <WrapperClockIcon>
                        <ClockIcon width={18} />
                      </WrapperClockIcon>
                    </WrapperTimePicker>
                  </>
                )}
            </Row>
          </Col>
        </Row>
        <Space height={20} />
        <Row>
          <Col lg={6} md={6} sm={24}>
            <Text>Cài đặt</Text>
          </Col>
          <Col lg={18}>
            {Object.keys(REPORT_OPTION).map(item => (
              <ReportFeature
                feature={REPORT_OPTION[item]}
                form={form}
                onSetBodyUpdate={handleSetBodyUpdate}
              />
            ))}
          </Col>
        </Row>
        {typeReport != undefined &&
          typeReport != ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT && (
            <>
              <Space height={50} />
              <Text size="xxs" textTransform="uppercase" weight="extraBold">
                Ứng dụng thông báo
              </Text>
              <Space height={15} />
              <Tabs defaultActiveKey="1">
                <Tabs.TabPane
                  key="1"
                  tab={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      <SlackIcon width={24} />
                      <Space width={10} />
                      Ứng dụng Slack
                    </span>
                  }
                >
                  <SlackApp
                    form={form}
                    listSlackGroup={listSlackGroup}
                    setListSlackGroup={setListSlackGroup}
                    onSetBodyUpdate={handleSetBodyUpdate}
                  />
                </Tabs.TabPane>
                <Tabs.TabPane
                  key="2"
                  tab={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      <TelegramContactIcon width={24} />
                      <Space width={10} />
                      Ứng dụng Telegram
                    </span>
                  }
                >
                  <TelegramApp
                    form={form}
                    listTelegramGroup={listTelegramGroup}
                    setListTelegramGroup={setListTelegramGroup}
                    onSetBodyUpdate={handleSetBodyUpdate}
                  />
                </Tabs.TabPane>
              </Tabs>
            </>
          )}
      </MainContent>
      <Footer
        content={['Hủy thêm mới', 'Hoàn thành']}
        isSubmitting={isSubmitting}
        onSubmit={handleSubmitBodyCreate}
      />
    </Form>
  );
};
